import { render, staticRenderFns } from "./InfoDocs.vue?vue&type=template&id=4438369c&"
import script from "./InfoDocs.vue?vue&type=script&lang=js&"
export * from "./InfoDocs.vue?vue&type=script&lang=js&"
import style0 from "./InfoDocs.vue?vue&type=style&index=0&id=4438369c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports